import {
  Box,
  Card,
  Collapse,
  CollapseProps,
  IconButton,
  Typography,
  alpha,
  useTheme,
} from "@material-ui/core";
import React, { memo } from "react";

import CloseIcon from "@material-ui/icons/Close";
import GenericSvgIconWrapper from "~/icons/genericSvgIconWrapper";
import styled from "styled-components";

export enum ALERT_CARD_TYPE {
  PLAIN = "plain",
  SUCCESS = "success",
  WARNING = "warning",
  ERROR = "error",
  INFO = "info",
}

interface NotificationCardProps {
  type: ALERT_CARD_TYPE;
  $noBorder?: boolean;
}

const NotificationCard = styled(Card)<NotificationCardProps>`
  ${({ theme, type, $noBorder }) => `
    border-width: ${$noBorder ? "0px" : "1px"};
    border-style: solid;
    border-color: ${
      $noBorder
        ? "transparent"
        : type === "plain"
        ? theme.palette.border.main
        : theme.palette[type].main
    };
    background-color: ${
      type === "plain"
        ? theme.palette.background.paper
        : alpha(theme.palette[type].main, 0.2)
    };
    color: ${theme.palette.text.primary};
    text-align: left;
    width: 100%;
    min-width: fit-content;
    display: flex;
    align-items: center;
    justify-content: space-between;
  `}
`;

const FullWidthCollapse = styled(Collapse)<CollapseProps>`
  width: 100%;
  ${(props) => (props.in ? "min-height: fit-content !important;" : "")}
`;

const NotificationCardContent = styled(Box)`
  padding: 0.25rem 0.75rem;
`;

interface AlertCardV2Props {
  children: any;
  isOpen: boolean;
  onClose?: () => void;
  type?: ALERT_CARD_TYPE;
  noBorder?: boolean;
}

const AlertCardV2 = memo<AlertCardV2Props>(function AlertCardV2(props) {
  const {
    children,
    isOpen,
    onClose,
    type = ALERT_CARD_TYPE.SUCCESS,
    noBorder = false,
    ...others
  } = props;
  const theme = useTheme();

  return (
    <FullWidthCollapse in={isOpen} timeout="auto" {...others}>
      <NotificationCard type={type} elevation={0} $noBorder={noBorder}>
        <NotificationCardContent width="100%">
          {typeof children === "string" && (
            <Typography variant="body1">{children}</Typography>
          )}
          {typeof children !== "string" && children}
        </NotificationCardContent>
        {onClose && (
          <IconButton aria-label="close notification" onClick={() => onClose()}>
            <GenericSvgIconWrapper $color={theme.palette.text.primary}>
              <CloseIcon />
            </GenericSvgIconWrapper>
          </IconButton>
        )}
      </NotificationCard>
    </FullWidthCollapse>
  );
});

export default AlertCardV2;
